module.exports = __webpack_public_path__ + "img/logobc.58f55c5c.png";